// Libs
import React from 'react';
import { Link } from 'react-router-dom';

// Services & Helpers
import API from 'API';

// Components
import Loader from 'components/common/Loader';

class ListSuppliers extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: true
        };
    }

    componentDidMount() {
        this.load();
    }

    async load() {
        this.setState({
            isLoading: true
        });
        const suppliers = await API.call('supplier/list');
        this.setState({
            isLoading: false,
            suppliers
        });
    }

    view(id) {
        this.props.history.push(`/admin/supplier/${id || 0}`);
    }

    render() {
        return (
            <section>

                <h2>Suppliers</h2>

                {this.renderInner()}

                <div className="control-panel">

                    <Link to="/admin/supplier/0" className="btn btn-primary">
                        <span className="fa-solid fa-plus" />{' '}
                        New Supplier
                    </Link>

                </div>

            </section>
        );
    }

    renderInner() {
        const {
            isLoading,
            suppliers
        } = this.state;

        if (isLoading) {
            return (<Loader />);
        }

        return (
            <table className="suppliers-table clickable">
                <thead>
                    <tr>
                        <th className="name-col">Name</th>
                        <th className="category-col">Category</th>
                        <th className="num-products-col"># Products</th>
                    </tr>
                </thead>
                <tbody>
                    {suppliers.map(supplier =>
                        <tr key={supplier.id} onClick={() => this.view(supplier.id)}>
                            <td className="name-col">{supplier.name}</td>
                            <td className="category-col">{supplier.category.name}</td>
                            <td className="num-products-col">{supplier.numProducts}</td>
                        </tr>
                    )}
                </tbody>
            </table>
        );
    }
}

export default ListSuppliers;
